const SelectionState = {
  COMMITTED: "COMMITTED",
  UNCOMMITTED: "UNCOMMITTED",
};
export default SelectionState;
